export default __webpack_public_path__ + "assets/images/fee2de3bc7a8fe2de7c73ce4b21e31d6.png";